/**
 * `1822` — *assign creator as {person, columnId}*. "Creator" is the **item's** creator, taken
 * from the trigger context, not the automation owner. Replaces the cell (ASSUMED, open question
 * 23: the add-vs-replace choice exists only on block `50`).
 */
import { z } from 'zod';
import { defineAction } from '../block.js';
import { columnRefSchema } from '../values.js';
export const assignCreatorParams = z.object({ columnId: columnRefSchema });
export const assignCreatorAction = defineAction({
    id: '1822',
    kind: 'action',
    app: 'monday',
    sentencePartial: 'assign creator as {person, columnId}',
    paramsSchema: assignCreatorParams,
    requiredColumnTypes: ['people', 'person'],
    executable: true,
    references: (params) => [{ kind: 'column', id: params.columnId.columnId, invalid: params.columnId.invalid }],
    async execute(context, params) {
        if (context.itemId === null)
            return { skipped: 'no_item' };
        const item = await context.services.getItem(context.itemId);
        if (item === null)
            return { skipped: 'item_deleted' };
        const creator = item.createdBy ?? context.event.actorId;
        if (creator === null)
            return { skipped: 'no_creator' };
        const result = await context.services.setCellValue({
            boardId: context.boardId,
            itemId: context.itemId,
            columnId: params.columnId.columnId,
            value: { personsAndTeams: [{ id: Number(creator), kind: 'person' }] },
        });
        return { creator, changed: result.changed };
    },
});
//# sourceMappingURL=1822.js.map